import { Add, Remove } from '@mui/icons-material';
import { Box, Button, Grid, Paper, TextField } from '@mui/material';
import { useEffect, useState } from 'react';
import { NaoConformidades } from '../../../services/api/action-plan/Aco';

interface RecommendationsProps {
    value: NaoConformidades[] | undefined
    onChange: (data: NaoConformidades[]) => void,
    smDown: boolean,
}

export const Conformity = ({value, onChange, smDown}:RecommendationsProps) => {

    const [ dataSeps, setDataSteps ] = useState<NaoConformidades[]>([]);

    const handleAdd = () => {
        const newItem: NaoConformidades = {};
        setDataSteps(prevDataSteps => {
          const newDataSteps = [...prevDataSteps, newItem];
          onChange(newDataSteps);
          return newDataSteps;
        });
    };

    const handleRemove = () => {
        setDataSteps(prevDataSteps => {
          const newDataSteps = prevDataSteps.slice(0, -1);
          onChange(newDataSteps);
          return newDataSteps;
        });
    };

    const handleChange = (index: number, field: keyof NaoConformidades, value: string) => {
        setDataSteps(prevDataSteps => {
          const newDataSteps = prevDataSteps.map((item, i) => i === index ? { ...item, [field]: value } : item);
          onChange(newDataSteps);
          return newDataSteps;
        });
    };

    useEffect(() => {
        if (value) {
            setDataSteps(value);
        }
    }, []);

    return(
        <Box padding={1}>
            <Box display={'flex'} flexDirection={smDown ? 'column' : 'row'} justifyContent={'center'} gap={2} padding={1}>
                <Button
                    variant='outlined'
                    startIcon={<Add/>}
                    sx={{borderRadius: '25px'}}
                    onClick={handleAdd}
                >
                    Adicionar
                </Button>
                <Button
                    variant='outlined'
                    startIcon={<Remove/>}
                    sx={{borderRadius: '25px'}}
                    onClick={handleRemove}
                >
                    Remover
                </Button>
            </Box>

            {dataSeps.map((item, index) => (
                <Box padding={1} component={Paper} sx={{borderRadius: '25px'}} key={index} margin={2}>
                        <Grid container padding={2} spacing={2}>
                            <Grid item xs={6}>
                                <TextField
                                    InputLabelProps={{ shrink: true }}
                                    label='Avaliação'
                                    value={item.avaliacao}
                                    name='avaliacao'
                                    fullWidth
                                    onChange={(e) => handleChange(index, 'avaliacao', e.target.value)}
                                />
                            </Grid>
                            <Grid item xs={6}>
                                <TextField
                                    InputLabelProps={{ shrink: true }}
                                    label='Não conformidade'
                                    value={item.nao_conformidade}
                                    name='nao_conformidade'
                                    fullWidth
                                    onChange={(e) => handleChange(index, 'nao_conformidade', e.target.value)}
                                />
                            </Grid>
                        </Grid>
                </Box>
            ))}
        </Box>
    );
};